import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';

export default function AddOrderButton({ productId }) {
  const history = useHistory();

  function addOrder(e) {
    e.preventDefault();
    fetch(
      `https://sheltered-badlands-71188.herokuapp.com/api/v1/order/${localStorage.getItem(
        '_id'
      )}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        body: JSON.stringify({
          productId: productId,
        }),
      }
    )
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        if (data) {
          Swal.fire({
            title: 'Order Created',
            icon: 'success',
            text: 'Successful Order Creation',
          }).then(() => history.go(0));
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Order Creation Failed.',
          });
        }
      });
  }

  return (
    <Button className='btn' onClick={addOrder}>
      Add to Cart
    </Button>
  );
}
